/* eslint-disable react/no-array-index-key */
import { Descriptions, Space } from 'antd';
import { VFC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { InventoryMeterOutputDescriptions } from 'components/descriptions/InventoryMeterOutput';
import { useStore } from '../../useStore';
import { RegisterDescriptions } from './RegisterDescriptions';
import { InstallationDescriptions as messages } from './messages';
import { outputTechnologyTranslated } from '../../../../components/Form/meter_details/messages';

export const InstallationDescriptions: VFC = () => {
  const intl = useIntl();
  const { registers, dataSourceId, meterMountTechnology, outputs } = useStore();

  return (
    <Space className="w-100" direction="vertical">
      <Descriptions bordered column={1} size="small" title={<FormattedMessage {...messages.title} />}>
        <Descriptions.Item label={<FormattedMessage {...messages.devEUISensor} />} span={1}>
          {dataSourceId}
        </Descriptions.Item>
        <Descriptions.Item label={<FormattedMessage {...messages.meterMountTechnologyLabel} />} span={1}>
          {meterMountTechnology ? intl.formatMessage(outputTechnologyTranslated[meterMountTechnology]) : ''}
        </Descriptions.Item>
      </Descriptions>
      {outputs.map((output, index) => (
        <InventoryMeterOutputDescriptions key={index} order={index + 1} output={output} />
      ))}
      {registers.map((register, index) => (
        <RegisterDescriptions key={register._id} order={index + 1} register={register} />
      ))}
    </Space>
  );
};
